(function() {
  var Service, jenks,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  jenks = require('node_modules/turf-jenks');

  exports.LegendService = (function(superClass) {
    extend(LegendService, superClass);

    function LegendService(rootScope) {
      this.rootScope = rootScope;
      this.calculateBreaks = bind(this.calculateBreaks, this);
      this.tryForMoreBreaks = bind(this.tryForMoreBreaks, this);
      this.generateCustomBreaks = bind(this.generateCustomBreaks, this);
      this.calculateCustomBreakCount = bind(this.calculateCustomBreakCount, this);
      this.prepareDataForBreaks = bind(this.prepareDataForBreaks, this);
      this.reclass = bind(this.reclass, this);
      this.stack = {};
      this.bin_colors = [];
      this.geojson_layer_rule = 'skip';
      this.colors = {
        dark_green: '#00FF00',
        green: '#7FFF00',
        yellow: '#FFFF00',
        orange: '#FF7F00',
        red: '#FF0000'
      };
      this.colors_by_breaks = {
        1: ['dark_green'],
        2: ['dark_green', 'red'],
        3: ['dark_green', 'yellow', 'red'],
        4: ['dark_green', 'yellow', 'orange', 'red'],
        5: ['dark_green', 'green', 'yellow', 'orange', 'red']
      };
    }

    LegendService.prototype.formatNumber = function(number) {
      return (number / 1000).toPrecision(3);
    };

    LegendService.prototype.calculateColorsByBreaks = function() {
      return this.current_colors = this.colors_by_breaks[this.break_count <= 5 ? this.break_count : this.break_count - 1];
    };

    LegendService.prototype.generateBinningColors = function() {
      var bin, i, j, len, ref, results;
      this.bin_colors = [];
      ref = this.bins;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        bin = ref[i];
        results.push(this.bin_colors.push([bin[0], bin[1], this.colors[this.current_colors[i]]]));
      }
      return results;
    };

    LegendService.prototype.calculateColors = function(attr) {
      if (attr == null) {
        attr = 'fillColor';
      }
      return this.reclass(this.geojson, this.property, attr, this.bin_colors);
    };

    LegendService.prototype.reclass = function(geojson, property, mapTo, values) {
      var bin, feature, j, k, len, len1, ref;
      ref = geojson.features;
      for (j = 0, len = ref.length; j < len; j++) {
        feature = ref[j];
        for (k = 0, len1 = values.length; k < len1; k++) {
          bin = values[k];
          if (feature.properties[property] >= bin[0] && feature.properties[property] <= bin[1]) {
            feature.properties[mapTo] = bin[2];
          }
        }
      }
      return geojson;
    };

    LegendService.prototype.unique = function(value, index, self) {
      return self.indexOf(value) === index;
    };

    LegendService.prototype.prepareDataForBreaks = function() {
      var feature, j, len, ref;
      this.values = [];
      ref = this.geojson.features;
      for (j = 0, len = ref.length; j < len; j++) {
        feature = ref[j];
        feature.properties[this.property] = Number(feature.properties[this.property]);
        this.values.push(feature.properties[this.property]);
      }
      return this.calculateBreakCount();
    };

    LegendService.prototype.update = function(geojson1, property1, max_breaks) {
      this.geojson = geojson1;
      this.property = property1 != null ? property1 : 'population';
      this.max_breaks = max_breaks != null ? max_breaks : 5;
      this.prepareDataForBreaks();
      this.calculateBreaks();
      this.calculateColorsByBreaks();
      this.calculateRanges();
      this.generateBinningColors();
      return this.calculateColors();
    };

    LegendService.prototype.calculateBreakCount = function() {
      this.number_of_unique_values = this.values.filter(this.unique).length;
      return this.break_count = this.number_of_unique_values >= this.max_breaks ? this.max_breaks : this.number_of_unique_values;
    };

    LegendService.prototype.calculateCustomBreakCount = function() {
      if (this.number_of_unique_values > this.max_breaks) {
        return Math.ceil(this.max_breaks / 2);
      } else {
        return Math.floor(this.number_of_unique_values / 2);
      }
    };

    LegendService.prototype.generateCustomBreaks = function() {
      var i, j, ref, values;
      this.breaks = [];
      values = this.values.filter(this.unique);
      for (i = j = 0, ref = this.calculateCustomBreakCount(); 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        this.breaks.push(values[i]);
        this.breaks.push(values[values.length - 1 - i]);
      }
      this.breaks.sort(function(a, b) {
        return a - b;
      });
      return this.break_count = this.breaks.length;
    };

    LegendService.prototype.tryForMoreBreaks = function() {
      var breaks, e, i, j, ref, ref1;
      breaks = [];
      for (i = j = ref = this.max_breaks, ref1 = this.number_of_unique_values; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
        try {
          breaks = jenks(this.geojson, this.property, i);
        } catch (error) {
          e = error;
          break;
        }
        if (breaks.filter(this.unique).length > this.max_breaks) {
          this.break_count = i;
          this.breaks = breaks;
          break;
        }
      }
      if (this.breaks.filter(this.unique).length <= this.max_breaks) {
        return this.generateCustomBreaks();
      }
    };

    LegendService.prototype.calculateBreaks = function() {
      this.breaks = jenks(this.geojson, this.property, this.break_count);
      if (this.break_count >= this.max_breaks) {
        if (this.number_of_unique_values > this.breaks.filter(this.unique).length) {
          return this.tryForMoreBreaks();
        }
      }
    };

    LegendService.prototype.generateRangeBreaks = function() {
      var breaks, i, j, ref;
      breaks = [];
      for (i = j = 0, ref = this.distinct_values.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        if (i === 0 || i === (this.distinct_values.length - 1)) {
          breaks.push(this.distinct_values[i]);
        } else {
          breaks.push((this.distinct_values[i] + this.distinct_values[i + 1]) / 2);
        }
      }
      this.breaks = breaks;
      return this.distinct_values = this.breaks.filter(this.unique);
    };

    LegendService.prototype.calculateRanges = function() {
      var i, j, k, ref, ref1, results, results1;
      this.bins = [];
      this.distinct_values = this.breaks.filter(this.unique);
      if (this.useValueInsteadOfRange()) {
        results = [];
        for (i = j = ref = this.distinct_values.length; ref <= 0 ? j < 0 : j > 0; i = ref <= 0 ? ++j : --j) {
          results.push(this.bins.push([this.distinct_values[i - 1], this.distinct_values[i - 1], "" + (i + 1)]));
        }
        return results;
      } else {
        this.generateRangeBreaks();
        results1 = [];
        for (i = k = ref1 = this.max_breaks; ref1 <= 0 ? k < 0 : k > 0; i = ref1 <= 0 ? ++k : --k) {
          results1.push(this.bins.push([this.distinct_values[i - 1], this.distinct_values[i], "" + (i + 1)]));
        }
        return results1;
      }
    };

    LegendService.prototype.constructRows = function() {
      var bin, j, k, len, len1, ref, ref1, rows;
      rows = [];
      if (this.useValueInsteadOfRange()) {
        ref = this.bin_colors;
        for (j = 0, len = ref.length; j < len; j++) {
          bin = ref[j];
          rows.push({
            range: "" + (this.formatNumber(bin[0])),
            style: {
              'background-color': "" + bin[2]
            }
          });
        }
      } else {
        ref1 = this.bin_colors;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          bin = ref1[k];
          rows.push({
            range: (this.formatNumber(bin[0])) + "-" + (this.formatNumber(bin[1])),
            style: {
              'background-color': "" + bin[2]
            }
          });
        }
      }
      return rows;
    };

    LegendService.prototype.updateMapProperties = function(geojson, desired_copy) {
      var f, j, len, ref;
      if (desired_copy == null) {
        desired_copy = 'fillColor';
      }
      ref = geojson.features;
      for (j = 0, len = ref.length; j < len; j++) {
        f = ref[j];
        if (f.properties[desired_copy] != null) {
          f.mapProperties[desired_copy] = f.properties[desired_copy];
        }
      }
      return geojson;
    };

    LegendService.prototype.useValueInsteadOfRange = function() {
      var ref;
      return this.break_count < this.max_breaks || ((ref = this.distinct_values) != null ? ref.length : void 0) <= this.max_breaks;
    };

    LegendService.prototype.getHTML = function() {
      return angular.element('#legend')[0].innerHTML;
    };

    LegendService.prototype.cacheHTML = function() {
      return this.html = this.getHTML();
    };

    LegendService.prototype.removeLegend = function() {
      return App.map.legendControl.removeLegend(this.html);
    };

    LegendService.prototype.addLegend = function() {
      return App.map.legendControl.addLegend(this.html);
    };

    LegendService.prototype.updateLegend = function() {
      if (this.html) {
        this.removeLegend();
      }
      this.cacheHTML();
      return this.addLegend();
    };

    LegendService.prototype.geojsonLayerHandlerProcessingRedirect = function(handler, layer_name, layer_id) {
      return handler.beforeProcess = (function(_this) {
        return function(response, geojson) {
          _this.processGeojsonLayer(geojson, handler, layer_name, layer_id);
          return _this.geojson_layer_rule;
        };
      })(this);
    };

    LegendService.prototype.processGeojsonLayer = function(geojson, handler, layer_name, layer_id) {
      var name;
      this.update(geojson);
      this.geojson = this.updateMapProperties(this.geojson);
      handler.applyLayerStyling(this.geojson);
      name = this.generateStackName(layer_name, layer_id);
      handler.callback = (function(_this) {
        return function() {
          _this.cleanup();
          _this.checkStack(name, true);
          if (_this.getPreviousStack()) {
            return _this.broadcast('stack-ready');
          }
        };
      })(this);
      handler.showLayer();
      handler.setOpacity(handler.defaultOpacity);
      this.broadcast('update-rows');
      return this.appendStack(name, this.constructRows());
    };

    LegendService.prototype.appendStack = function(name, data) {
      return this.stack[name] = data;
    };

    LegendService.prototype.checkStack = function(name, del) {
      if (del == null) {
        del = false;
      }
      if (del && (this.stack[name] != null)) {
        this.deleteFromStack(name);
        return true;
      } else if (this.stack[name] != null) {
        return this.stack[name];
      }
      return false;
    };

    LegendService.prototype.deleteFromStack = function(name) {
      return delete this.stack[name];
    };

    LegendService.prototype.getPreviousStack = function() {
      return this.stack[Object.keys(this.stack).slice(-1).pop()];
    };

    LegendService.prototype.comparePreviousStackValues = function(a) {
      return _.isEqual(a, this.getPreviousStack());
    };

    LegendService.prototype.generateStackName = function(layer_name, layer_id) {
      return "" + layer_name + layer_id;
    };

    LegendService.prototype.broadcast = function(message) {
      return this.rootScope.$broadcast("legend:" + message);
    };

    LegendService.prototype.cleanup = function() {
      this.bins = [];
      this.bin_colors = [];
      this.breaks = [];
      this.geojson = null;
      this.property = '';
      if (this.html != null) {
        this.removeLegend();
      }
      return this.html = '';
    };

    return LegendService;

  })(Service);

}).call(this);
